import { useCallback, useMemo, useState } from 'react';

// Adapts CommonDataGrid expansion options to MUI detail-panel props.
const useExpandableRows = (options) => {
  const [expandedRowIds, setExpandedRowIds] = useState(() => options?.initialExpandedRowIds || []);
  const renderContent = options?.renderContent;
  const controlledRowIds = options?.expandedRowIds;
  const onExpandedRowIdsChange = options?.onExpandedRowIdsChange;
  const panelHeight = options?.getHeight;

  const getDetailPanelHeight = useCallback(
    (params) => (typeof panelHeight === 'function' ? panelHeight(params) : panelHeight ?? 250),
    [panelHeight]
  );

  const handleExpandedRowIdsChange = useCallback(
    (ids) => {
      setExpandedRowIds(ids);
      onExpandedRowIdsChange?.(ids);
    },
    [onExpandedRowIdsChange]
  );

  return useMemo(
    () =>
      renderContent
        ? {
            getDetailPanelContent: renderContent,
            getDetailPanelHeight,
            detailPanelExpandedRowIds: controlledRowIds ?? expandedRowIds,
            onDetailPanelExpandedRowIdsChange: handleExpandedRowIdsChange,
          }
        : {},
    [
      renderContent,
      getDetailPanelHeight,
      controlledRowIds,
      expandedRowIds,
      handleExpandedRowIdsChange,
    ]
  );
};

export default useExpandableRows;
